import * as yup from 'yup';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';

export function GenericInputActionDialog(props) {
	const { t } = useTranslation(['common', 'validation']);
	const mainTheme = useSelector(selectMainTheme);

	const fields = [
		{
			key: 'name',
			text: 'Name',
			required: true,
			inputType: 'text'
		},
		...(props.extraFields || [])
	];

	const schemaShape = fields.reduce((acc, field) => {
		let validator = field.multiple
			? yup.array().nullable()
			: yup.mixed().nullable();

		if (field.required) {
			validator = validator.required(
				t('validation:FIELD_REQUIRED')
			);
		}

		acc[field.key] = validator;

		return acc;
	}, {});

	const schema = yup.object().shape(schemaShape);

	const methods = useForm({
		defaultValues: props.defaultValues || {},
		mode: 'onChange',
		resolver: yupResolver(schema)
	});

	const renderField = (fieldConfig, field, fieldState) => {
		if (fieldConfig.inputType === 'select') {
			return (
				<EditFormSelectField
					field={field}
					fieldState={fieldState}
					config={{
						topic: fieldConfig.topic || 'common'
					}}
					fieldConfig={fieldConfig}
				/>
			);
		}

		return (
			<EditFormTextField
				field={field}
				fieldState={fieldState}
				config={{
					topic: fieldConfig.topic || 'common'
				}}
				fieldConfig={fieldConfig}
			/>
		);
	};

	const handleSave = value => {
		props.onSave(value);
	};

	const handleCancel = () => {
		props.onCancel();
	};

	return (
		<ThemeProvider theme={mainTheme}>
			<Dialog open fullWidth>
				<DialogTitle disableTypography className="border-b">
					{props.title}
				</DialogTitle>

				<DialogContent className="p-20">
					<FormProvider {...methods}>
						{fields.map(fieldConfig => (
							<Controller
								key={fieldConfig.key}
								control={methods.control}
								name={fieldConfig.key}
								render={({ field, fieldState }) =>
									renderField(
										fieldConfig,
										field,
										fieldState
									)
								}
							/>
						))}
					</FormProvider>
				</DialogContent>

				<DialogActions className="justify-between border-t p-20">
					<Button onClick={() => { handleCancel(); }}>
						{t('CANCEL')}
					</Button>

					<Button
						onClick={methods.handleSubmit(handleSave)}
						color="primary"
						autoFocus
					>
						{props.buttonLabel}
					</Button>
				</DialogActions>

			</Dialog>
		</ThemeProvider>
	);
}

export default GenericInputActionDialog;